module.exports = __webpack_public_path__ + "img/view_device_c6.181af1d8.jpg";